import { Box, Header, Link, SpaceBetween } from '@cloudscape-design/components';

import { Place } from '../common/types';
import { PlaceStatus } from './PlaceStatus';
import { StarsIcon } from './StarsIcon';
import { formatDateString, formatTime } from '../common/formatting/dateFormat';

export type PlaceNameCellProps = {
  place: Place;
};

/**
 * The complex "Place" column cell shared by the places dashboard table and
 * the chain locations table: place name (link to the place detail page) with
 * a description block of address, rating + stars + Google reviews link, and
 * the collection status + last-updated time.
 *
 * Extracted from PlaceTable so both tables render an identical Place cell.
 */
export function PlaceNameCell({ place }: PlaceNameCellProps) {
  return (
    <Header
      variant="h2"
      description={
        <SpaceBetween direction="vertical" size="xxxs">
          {place.address}
          <SpaceBetween direction="horizontal" size="xs">
            {place.rating?.toFixed(1) ?? '?.?'}
            <StarsIcon stars={place.rating ?? undefined} />
            <Link href={place.cid_url ?? undefined} target="_blank" variant="secondary">
              {place.total_review_count?.toLocaleString() ?? '?'} Google reviews
            </Link>
          </SpaceBetween>
          <SpaceBetween size="xs" direction="horizontal">
            <PlaceStatus tasks={place.tasks} text={formatDateString(place.updated_at)} />
            <Box variant="span" color="text-body-secondary">
              {formatTime(new Date(place.updated_at + 'Z'))}
            </Box>
          </SpaceBetween>
        </SpaceBetween>
      }
    >
      <Link href={`/dashboard/places/${place.uuid}`} variant="secondary" target="_blank">
        {place.name}
      </Link>
    </Header>
  );
}
